import LinkComponent from "@Components/Link";
import { useLocaleRouter } from "@wff/hooks/useLocaleRouter";

interface ProductLinkProps {
  children: React.ReactNode;
  title: string;
  to: string;
  className?: string;
}

export const ProductLink = ({
  children,
  to,
  title,
  className,
}: ProductLinkProps) => {
  const { getLocalePath } = useLocaleRouter();
  const href = getLocalePath(to);

  return (
    <LinkComponent href={href}>
      <a aria-label={title} className={className}>
        {children}
      </a>
    </LinkComponent>
  );
};
ProductLink.defaultProps = {
  className: "",
};
